//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MonacoEditor from '@/views/visual/dataScreen/components/editor';
export default {
  components: {
    MonacoEditor: MonacoEditor
  },
  inject: ["contain"],
  data: function data() {
    return {
      show: false,
      json: {}
    };
  },
  methods: {
    open: function open() {
      this.json = {
        config: this.contain.config,
        component: this.contain.nav
      };
    },
    importData: function importData() {
      try {
        var json = JSON.parse(this.json);
        this.contain.config = json.config;
        this.contain.nav = json.component;
        this.show = false;
        this.$message.success('数据导入成功');
      } catch (_unused) {
        this.$message.error('导入数据错误');
      }
    },
    exportData: function exportData() {
      var zip = new window.JSZip();
      zip.file("data.txt", this.json);
      zip.generateAsync({
        type: "base64"
      }).then(function (content) {
        location.href = "data:application/zip;base64," + content;
      });
    }
  }
};